//  import { useEffect, useRef, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { getSocket } from "../socket";

// /* -------- COMMON USER ID HELPER -------- */
// const getMyId = () => {
//   const token = localStorage.getItem("token");
//   if (!token) return null;
//   try {
//     const decoded = JSON.parse(atob(token.split(".")[1]));
//     return (decoded.userId || decoded.id)?.toString();
//   } catch {
//     return null;
//   }
// };

// function ChatPage({ clearNotifications }) {
//   const { conversationId } = useParams();
//   const navigate = useNavigate();
//   const token = localStorage.getItem("token");

//   const userId = getMyId();

//   const [socket, setSocket] = useState(null);
//   const [messages, setMessages] = useState([]);
//   const [newMessage, setNewMessage] = useState("");
//   const [otherUserId, setOtherUserId] = useState(null);

//   const messagesEndRef = useRef(null);

//   /* ---------------- SOCKET READY ---------------- */
//   useEffect(() => {
//     const s = getSocket();
//     if (s) setSocket(s);
//   }, []);

//   /* ---------------- CLEAR NOTIFICATIONS ---------------- */
//   useEffect(() => {
//     clearNotifications?.();
//   }, [clearNotifications]);

//   /* ---------------- FETCH OLD MESSAGES ---------------- */
//   useEffect(() => {
//     const fetchMessages = async () => {
//       try {
//         const res = await fetch(
//           ` https://borrowhub-backend.onrender.com/api/chat/${conversationId}`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );

//         if (!res.ok) {
//           if (res.status === 401) navigate("/chats", { replace: true });
//           return;
//         }

//         const data = await res.json();
//         if (Array.isArray(data)) setMessages(data);
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     if (conversationId && token) fetchMessages();
//   }, [conversationId, token, navigate]);

//   /* ---------------- FETCH OTHER USER ---------------- */
//   useEffect(() => {
//     const fetchConversation = async () => {
//       try {
//         const res = await fetch(
//           ` https://borrowhub-backend.onrender.com/api/chat/conversation/${conversationId}`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );

//         if (!res.ok) {
//           if (res.status === 401) navigate("/chats", { replace: true });
//           return;
//         }

//         const convo = await res.json();
//         const other = convo.participants.find(
//           (p) => p._id.toString() !== userId
//         );

//         if (other) setOtherUserId(other._id.toString());
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     if (conversationId && userId) fetchConversation();
//   }, [conversationId, userId, token, navigate]);

//   /* ---------------- JOIN / LEAVE ROOM ---------------- */
//   useEffect(() => {
//     if (!socket || !conversationId) return;

//     socket.emit("joinRoom", { roomId: conversationId });
//     return () => socket.emit("leaveRoom", { roomId: conversationId });
//   }, [socket, conversationId]);

//   /* ---------------- RECEIVE MESSAGE ---------------- */
//   useEffect(() => {
//     if (!socket) return;

//     const handler = (serverMsg) => {
//       setMessages((prev) => {
//         if (serverMsg.clientId) {
//           const exists = prev.find(
//             (m) => m.clientId === serverMsg.clientId
//           );
//           if (exists) {
//             return prev.map((m) =>
//               m.clientId === serverMsg.clientId ? serverMsg : m
//             );
//           }
//         }
//         return [...prev, serverMsg];
//       });
//     };

//     socket.on("receiveMessage", handler);
//     return () => socket.off("receiveMessage", handler);
//   }, [socket]);

//   /* ---------------- AUTO SCROLL ---------------- */
//   useEffect(() => {
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages]);

//   /* ---------------- SEND MESSAGE ---------------- */
//   const sendMessage = () => {
//     if (!socket || !newMessage.trim() || !otherUserId || !userId) return;

//     const text = newMessage;
//     setNewMessage("");

//     const clientId = Date.now().toString();

//     setMessages((prev) => [
//       ...prev,
//       {
//         _id: clientId,
//         clientId,
//         text,
//         sender: userId,
//         createdAt: new Date(),
//         delivered: false,
//         seen: false,
//       },
//     ]);

//     socket.emit("sendMessage", {
//       roomId: conversationId,
//       message: { text },
//       receiverId: otherUserId,
//       clientId,
//     });
//   };

//   return (
//     <div className="vh-100 d-flex flex-column bg-light">
//       {/* HEADER */}
//       <div className="p-3 bg-success text-white fw-bold fs-5">
//         BorrowHub Chat
//       </div>

//       {/* MESSAGES */}
//       <div className="flex-grow-1 overflow-auto p-3">
//         {messages.map((msg) => {
//           const isMe =
//             (msg.sender?._id || msg.sender)?.toString() === userId;

//           return (
//             <div
//               key={msg._id}
//               className={`mb-2 d-flex ${
//                 isMe ? "justify-content-end" : "justify-content-start"
//               }`}
//             >
//               <div
//                 className={`p-3 rounded ${
//                   isMe ? "bg-success text-white" : "bg-white"
//                 }`}
//                 style={{ maxWidth: "70%", fontSize: 16 }}
//               >
//                 {msg.text}
//               </div>
//             </div>
//           );
//         })}
//         <div ref={messagesEndRef} />
//       </div>

//       {/* INPUT */}
//       <div className="p-3 d-flex gap-2 border-top bg-white">
//         <input
//           className="form-control"
//           placeholder="Type a message..."
//           value={newMessage}
//           onChange={(e) => setNewMessage(e.target.value)}
//         />
//         <button className="btn btn-success px-4" onClick={sendMessage}>
//           Send
//         </button>
//       </div>
//     </div>
//   );
// }

// export default ChatPage;


  import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { connectSocket, getSocket } from "../socket";

function ChatPage({ clearNotifications }) {
  const { conversationId } = useParams();
  const token = localStorage.getItem("token");
  
  // User ID nikaalne ka safe tarika
  const getMyId = () => {
    if (!token) return null;
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      return (payload.userId || payload.id)?.toString();
    } catch (e) { return null; }
  };
  const myId = getMyId();

  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [otherUserId, setOtherUserId] = useState(null);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    if (!token) return;
    const socket = connectSocket(token);
    
    // Room Join karo
    console.log("Joining Room:", conversationId);
    socket.emit("joinRoom", { roomId: conversationId });

    // Message Listener
    const handler = (msg) => {
      console.log("New Message Received:", msg);
      setMessages((prev) => [...prev, msg]);
    };
    socket.on("receiveMessage", handler);

    return () => socket.off("receiveMessage", handler);
  }, [conversationId, token]);

  // Data Fetching
  useEffect(() => {
    // 1. Chat History
    fetch(` https://borrowhub-backend.onrender.com/api/chat/${conversationId}`, { 
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(res => res.json())
    .then(data => {
      if (Array.isArray(data)) setMessages(data);
    });

    // 2. Dusre User ki ID dhoondo
    fetch(` https://borrowhub-backend.onrender.com/api/chat/conversation/${conversationId}`, { 
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(res => res.json())
    .then(convo => {
      if (convo && convo.participants) {
        const other = convo.participants.find(p => (p._id || p).toString() !== myId);
        if (other) setOtherUserId((other._id || other).toString());
      }
    });
  }, [conversationId, token, myId]);

  const sendMessage = () => {
    const socket = getSocket();
    if (!socket || !newMessage.trim()) {
      console.log("❌ Socket or Message missing");
      return;
    }

    // 🔥 FORCE SEND: Agar receiverId nahi bhi mili, toh bhi room me bhejo
    const payload = {
      roomId: conversationId,
      message: { text: newMessage },
      receiverId: otherUserId // Ye null ho sakta hai, par backend sambhal lega
    };

    console.log("📤 Sending:", payload);
    socket.emit("sendMessage", payload);
    setNewMessage("");
  };

  // Auto Scroll
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className="vh-100 d-flex flex-column p-3 bg-light">
      <div className="flex-grow-1 overflow-auto mb-3">
        {messages.map((m, i) => {
          // Check karo message mera hai ya kisi aur ka
          const senderId = (m.sender?._id || m.sender)?.toString();
          const isMe = senderId === myId;
          
          return (
            <div key={i} className={`mb-2 d-flex ${isMe ? "justify-content-end" : "justify-content-start"}`}>
              <div className={`p-2 rounded shadow-sm ${isMe ? "bg-success text-white" : "bg-white text-dark"}`} style={{ maxWidth: "75%" }}>
                {m.text}
              </div>
            </div>
          );
        })}
        <div ref={messagesEndRef} />
      </div>

      <div className="d-flex gap-2">
        <input 
          className="form-control" 
          value={newMessage} 
          onChange={(e) => setNewMessage(e.target.value)} 
          placeholder="Type a message..."
          onKeyPress={(e) => e.key === 'Enter' && sendMessage()} 
        />
        <button className="btn btn-success" onClick={sendMessage}>Send</button>
      </div>
    </div>
  );
}

export default ChatPage;